import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { ROOT_PATHS } from '../constants/paths.constants';
import { AuthService } from '../services/auth/auth.service';

export const authenticationGuard = async (): Promise<boolean> => {
  const authenticationService = inject(AuthService);
  const router = inject(Router);

  try {
    const isLoginOn = await authenticationService.isLoginOn();
    if (isLoginOn) {
      return true;
    }
  } catch (error: any) {
    console.error(error);
  }
  await router.navigate([ROOT_PATHS.login]);
  return false;
};
